import React from 'react';

export default function FeatureBadge({ type }) {
    if (!type) return null;
    const updated = type === 'updated';
    return <span className={`ml-2 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${updated ? 'border border-amber-300 bg-amber-100 text-amber-800' : 'bg-brandRed text-white'}`}>
        {updated ? 'Updated' : 'New'}
    </span>;
}
